import React from 'react';
import { generateAppointmentQRCode, sendMobileCheckInEmail } from '../../API/GoMoto';
import { useAppointmentState, useMaskPhone, useMaskEmail, useMaskVin } from '../../context/Appointment/appointment';
import { useKioskState } from '../../context/Kiosk/kiosk';
import { useLocale, useLocalization } from '../../context/Localization/localization';
import { ImageHelper } from '../../controls/ImageHelper/ImageHelper';
import { Spinner } from '../../controls/Spinner/Spinner';
import css from './AppointmentQRCode.module.scss';
import type { AppointmentQRCodeProps } from './AppointmentQRCode.types';

/**
 * Generates the QR code for the appointment and displays it.
 */
export const AppointmentQRCode = React.memo(({ mobileCheckInComplete, currentUrl, email = true, lockerNumber = 0 }: AppointmentQRCodeProps) => {
    const appointment = useAppointmentState();
    const maskPhone = useMaskPhone();
    const maskEmail = useMaskEmail();
    const maskVin = useMaskVin();
    const locale = useLocale();
    const Localization = useLocalization();
    const [qrCode, setQRCode] = React.useState('');
    const {
        dealer: { key: dealerKey },
        kioskType,
    } = useKioskState();

    React.useEffect(() => {
        if (!qrCode) {
            const generateQRCode: Promise<string> = email
                ? sendMobileCheckInEmail(
                    appointment.key,
                    dealerKey,
                    locale,
                    mobileCheckInComplete || false,
                    currentUrl,
                    maskPhone,
                    maskEmail,
                    maskVin,
                    appointment.phoneTypeEnum,
                )
                : generateAppointmentQRCode(
                    appointment.key,
                    dealerKey,
                    locale,
                    mobileCheckInComplete || false,
                    currentUrl,
                    lockerNumber,
                    maskPhone,
                    maskEmail,
                    maskVin,
                    appointment.phoneTypeEnum,
                    kioskType === 'outdoor',
                );

            generateQRCode.then((qrCode) => {
                setQRCode(qrCode);
            });
        }
    }, [appointment, dealerKey, currentUrl, locale, mobileCheckInComplete, qrCode, email, lockerNumber, maskPhone, maskEmail, maskVin, kioskType]);

    return !qrCode ? (
        <Spinner />
    ) : (
        <div className={css.appointmentQRCodeWrapper} data-testid={'appointment-qr-code'}>
            <div className={css.qrCode}>
                <ImageHelper
                    imageProps={{
                        src: qrCode,
                        alt: Localization.QRCodeIcon,
                    }}
                />
            </div>
        </div>
    );
});
